import { Card } from 'antd';
import { Title } from 'components';

import ArticleGroupDataTable from './article-group-data-table';

function ArticleGroupManagement() {
  return (
    <Card>
      <Title>Madde Grup Yönetimi</Title>
      <h2 className="gx-h1-lg">Madde Grup Yönetimi</h2>
      <p>Madde gruplarını görüntüleyebilir ve düzenleyebilirsiniz.</p>
      <ArticleGroupDataTable />
    </Card>
  );
}

export default ArticleGroupManagement;
